import { useSelector } from "react-redux";

export default function useGetSingleTourneyDefinitionById(tourneyId) {
  const tourney = useSelector((state) => {
    const data = state?.lobby?.masterTourneysData;
    if (!data) return null;
    return data.get ? data.get(tourneyId) : null;
  });

  if (!tourney) {
    console.warn(`Tourney with id ${tourneyId} not found`);
    return null;
  }

  return tourney;
}
